const Footer = () => (
  <div className="h-14 w-full absolute bottom-0 left-0 flex items-center p-4 bg-dark-footer">
    <p className="text-white text-sm">Copyright © Mars 2024</p>
  </div>
);

export default Footer;
